import { ref, computed } from 'vue';

const STORAGE_KEY = 'uiTheme';
const MODE_STORAGE_KEY = 'uiThemeMode';
const STYLE_STORAGE_KEY = 'uiThemeStyle';
export const DEFAULT_THEME = 'dark';
export const DEFAULT_THEME_BY_MODE = { dark: 'dark', light: 'light' };

export const THEMES = [
  { id: 'dark', label: 'theme.dark', mode: 'dark' },
  { id: 'light', label: 'theme.light', mode: 'light' },
  { id: 'pink', label: 'theme.pink', mode: 'dark' },
  { id: 'violet', label: 'theme.violet', mode: 'dark' },
  { id: 'lime', label: 'theme.lime', mode: 'dark' },
];

// tokens the theme editor sets by hand; the rest stay derived from the seeds
export const OVERRIDABLE_TOKENS = [
  'bg2', 'control', 'card', 'chrome', 'line',
  'text-muted', 'accent-soft',
  'red', 'green', 'blue',
];

const modeStorageKey = mode => `${STORAGE_KEY}-${mode}`;

export const themeStyle = theme => ({
  '--base': theme.seeds.base,
  '--ink': theme.seeds.ink,
  '--accent': theme.seeds.accent,
  ...Object.fromEntries(Object.entries(theme.overrides).map(([token, color]) => [`--${token}`, color])),
});

export const currentTheme = ref(localStorage.getItem(STORAGE_KEY) || DEFAULT_THEME);
const currentMode = ref(localStorage.getItem(MODE_STORAGE_KEY) || 'dark');
export const isLight = computed(() => currentMode.value === 'light');

let paintedStyle = {};

function paint(id, mode, style) {
  const root = document.documentElement;
  Object.keys(paintedStyle).forEach(prop => root.style.removeProperty(prop));
  Object.entries(style).forEach(([prop, value]) => root.style.setProperty(prop, value));
  paintedStyle = style;
  root.setAttribute('data-theme', id);
  root.setAttribute('data-mode', mode);
  currentTheme.value = id;
  currentMode.value = mode;
}

function paintStored() {
  paint(
    localStorage.getItem(STORAGE_KEY) || DEFAULT_THEME,
    localStorage.getItem(MODE_STORAGE_KEY) || 'dark',
    JSON.parse(localStorage.getItem(STYLE_STORAGE_KEY) || '{}'),
  );
}

export function applyTheme(theme) {
  const style = theme.seeds ? themeStyle(theme) : {};
  paint(theme.id, theme.mode, style);
  localStorage.setItem(MODE_STORAGE_KEY, theme.mode);
  localStorage.setItem(STYLE_STORAGE_KEY, JSON.stringify(style));
  localStorage.setItem(modeStorageKey(theme.mode), theme.id);
  localStorage.setItem(STORAGE_KEY, theme.id);
}

export const lastThemeIdOfMode = mode => localStorage.getItem(modeStorageKey(mode)) || DEFAULT_THEME_BY_MODE[mode];

paintStored();

window.addEventListener('storage', (e) => {
  if (e.key === STORAGE_KEY || e.key === STYLE_STORAGE_KEY) paintStored();
});
